import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobanglorecab() {



  const cardData = {
  "keyword": "Pune to Bangalore Cab Service",

  "headingDescription":
    "Shivai Travels offers reliable and comfortable Pune to Bangalore Cab Service for travelers looking for safe, affordable, and hassle-free intercity transportation between Maharashtra and Karnataka. Whether you are traveling for business meetings, family visits, IT sector work, educational purposes, vacations, or long-distance personal travel, our taxi service ensures a smooth and stress-free journey. Our experienced drivers are familiar with national highways and long-distance travel routes, ensuring safety and timely travel throughout the journey. We provide clean, air-conditioned, and well-maintained vehicles including sedans, SUVs, Innova cars, and premium taxis suitable for solo travelers, families, and corporate groups. With flexible one-way and round-trip booking options, doorstep pickup from Pune, transparent pricing without hidden charges, and 24/7 customer support, Shivai Travels delivers a convenient and comfortable Pune to Bangalore cab travel experience.",

  "topPlaces": [
    {
      "title": "Bangalore Palace",
      "description":
        "Bangalore Palace is one of the city’s most famous landmarks known for its royal architecture, beautiful interiors, and historic importance inspired by England’s Windsor Castle."
    },
    {
      "title": "Lalbagh Botanical Garden",
      "description":
        "Lalbagh Botanical Garden is a popular tourist attraction in Bangalore featuring rare plant species, a glass house, scenic walking paths, and peaceful greenery."
    },
    {
      "title": "Cubbon Park",
      "description":
        "Cubbon Park is a large green park in the center of Bangalore offering relaxing surroundings, walking trails, gardens, and recreational spaces for visitors."
    },
    {
      "title": "ISKCON Temple Bangalore",
      "description":
        "ISKCON Temple Bangalore is a famous spiritual destination dedicated to Lord Krishna, known for its grand architecture, devotional atmosphere, and cultural activities."
    },
    {
      "title": "Vidhana Soudha",
      "description":
        "Vidhana Soudha is an iconic government building in Bangalore admired for its impressive neo-Dravidian architecture and historical significance."
    },
    {
      "title": "Wonderla Amusement Park",
      "description":
        "Wonderla is a popular amusement and water park near Bangalore offering thrilling rides, entertainment activities, and family-friendly attractions."
    },
    {
      "title": "Nandi Hills",
      "description":
        "Nandi Hills is a scenic hill station near Bangalore known for sunrise views, pleasant weather, greenery, and peaceful surroundings ideal for weekend trips."
    },
    {
      "title": "Commercial Street",
      "description":
        "Commercial Street is one of Bangalore’s busiest shopping destinations featuring clothing stores, footwear shops, restaurants, and local markets."
    },
    {
      "title": "Bannerghatta Biological Park",
      "description":
        "Bannerghatta Biological Park is a famous wildlife attraction offering safari rides, a zoo, butterfly park, and opportunities to explore nature near Bangalore."
    },
    {
      "title": "Mysore Road & Western Ghats Route",
      "description":
        "The Pune to Bangalore route passes through beautiful highways, green landscapes, and scenic stretches of Karnataka, making the road journey comfortable and enjoyable."
    }
  ],



services: [
  {
    name: "Pune to Bangalore Cab",
    description: "Pune to Bangalore cab service provides reliable transportation for passengers traveling between Pune and Bangalore with comfortable vehicles and experienced drivers. Vehicles are suitable for long-distance interstate highway travel ensuring smooth and timely journeys for families, tourists, business travelers, and local passengers. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient Pune to Bangalore cab reservations."
  },
  {
    name: "Pune to Bangalore Taxi",
    description: "Pune to Bangalore taxi service offers dependable transportation for interstate and outstation travel with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, family travel, tourism, and intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Pune to Bangalore taxi reservations."
  },
  {
    name: "Cab from Pune to Bangalore",
    description: "Cab from Pune to Bangalore service provides comfortable transportation for passengers traveling from Pune to Bangalore and nearby destinations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth travel journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and nearby locations across Pune. Ideal for business travelers, tourists, and family travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Bangalore",
    description: "Taxi from Pune to Bangalore service offers reliable transportation with comfortable vehicles and professional drivers for passengers requiring direct travel between Pune and Bangalore. Vehicles provide smooth city and highway travel suitable for tourism, business visits, corporate travel, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available directly from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Bangalore Cab Service",
    description: "Pune to Bangalore cab service provides dependable transportation solutions for outstation travel between Pune and Bangalore. Vehicles are suitable for long-distance travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, corporate tours, tourism trips, and family outstation travel. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Pune to Bangalore Taxi Fare",
    description: "Pune to Bangalore taxi fare service provides transparent and reliable transportation options for travelers planning budget-friendly travel between Pune and Bangalore. Travelers can enjoy smooth journeys with experienced drivers familiar with interstate routes and highway conditions. Comfortable vehicles ensure timely travel with safe transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient taxi fare cab reservations."
  },
  {
    name: "Pune to Bangalore One Way Cab",
    description: "Pune to Bangalore one way cab service provides economical and comfortable transportation for travelers planning one-side travel between Pune and Bangalore. Comfortable vehicles ensure smooth highway travel suitable for business trips, tourism, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Bangalore Round Trip Taxi",
    description: "Pune to Bangalore round trip taxi service offers spacious transportation for families and groups traveling between Pune and Bangalore with return travel options. Vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for family outings and corporate travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip taxi reservations."
  },
  {
    name: "Pune to Bangalore Cab Booking",
    description: "Pune to Bangalore cab booking service provides premium transportation for passengers seeking comfortable and reliable interstate travel. Vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, business trips, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Cheap Pune to Bangalore Cab",
    description: "Cheap Pune to Bangalore cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Bangalore. Vehicles provide smooth highway travel with comfortable seating and luggage space suitable for one-way and round-trip journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Bangalore Taxi",
    description: "Best Pune to Bangalore taxi service offers dependable transportation for passengers planning direct interstate travel between Pune and Bangalore. Comfortable vehicles ensure smooth highway travel suitable for tourism, business travel, and family trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Bangalore Cab",
    description: "Sedan Pune to Bangalore cab service provides reliable transportation for travelers planning long-distance journeys between Pune and Bangalore. Sedan vehicles ensure smooth and safe travel suitable for tourists, families, business travelers, and vacation travelers. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Bangalore Taxi",
    description: "SUV Pune to Bangalore taxi service offers comfortable transportation for passengers looking for spacious and reliable travel services between Pune and Bangalore. SUV vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for business trips, family tours, interstate travel, and outstation travel requirements. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Bangalore Cab",
    description: "Innova Pune to Bangalore cab service provides dependable transportation for passengers planning premium interstate travel between Pune and Bangalore. Innova vehicles ensure smooth highway travel suitable for tourism, corporate travel, airport visits, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Outstation Cab Pune to Bangalore",
    description: "Outstation cab Pune to Bangalore service provides affordable and convenient transportation for passengers traveling between Pune and Bangalore through major interstate highway routes. Vehicles ensure reliable highway travel with experienced drivers offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for tourists, corporate travelers, family trips, and long-distance outstation travel requirements. Flexible booking options allow convenient outstation cab reservations."
  }
],

tableData: [
  ["Pune to Bangalore Cab", "Pune to Bangalore Taxi"],
  ["Cab from Pune to Bangalore", "Taxi from Pune to Bangalore"],
  ["Pune to Bangalore Cab Service", "Pune to Bangalore Taxi Fare"],
  ["Pune to Bangalore One Way Cab", "Pune to Bangalore Round Trip Taxi"],
  ["Pune to Bangalore Cab Booking", "Cheap Pune to Bangalore Cab"],
  ["Best Pune to Bangalore Taxi", "Sedan Pune to Bangalore Cab"],
  ["SUV Pune to Bangalore Taxi", "Innova Pune to Bangalore Cab"],
  ["Outstation Cab Pune to Bangalore", "Pune to Bangalore Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Bangalore Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Bangalore cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe interstate travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Bangalore Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Bangalore cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Bangalore Cab Availability",
        WhyChoosedescription: "Our Pune to Bangalore cab service operates 24 hours a day for family travel, corporate trips, business meetings, airport transfers, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide comfortable long-distance interstate travel experiences."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Bangalore taxi service, round-trip bookings, corporate travel, and customized interstate travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, Tempo Travellers, and Urbania suitable for individuals, families, tourists, and corporate travelers."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Interstate Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Bangalore highway routes and ensure safe driving, smooth travel, and timely arrival for every long-distance journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Bangalore cab service?", answer: "Pune to Bangalore cab service provides comfortable taxi transportation between Pune and Bangalore for family travel, business trips, and interstate journeys." },
    { question: "Is Pune to Bangalore cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Bangalore cab service." },
    { question: "Which vehicles are available for Pune to Bangalore travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, Tempo Travellers, and Urbania vehicles." },
    { question: "Can I book a one-way cab from Pune to Bangalore?", answer: "Yes, customers can book one-way as well as round-trip Pune to Bangalore taxi services." },
    { question: "Do you provide corporate cab service for Bangalore travel?", answer: "Yes, Shivai Travels provides corporate taxi services and customized business travel packages for Bangalore." },
    { question: "Are all Pune to Bangalore taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Bangalore cab service online?", answer: "Yes, customers can easily book Pune to Bangalore cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours, group travel, and corporate transportation." },
    { question: "Are Pune to Bangalore cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Bangalore cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Kulkarni",
      feedback:
        "Booked Pune to Bangalore cab service with Shivai Travels. Comfortable vehicle, smooth interstate journey, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Patil",
      feedback:
        "Excellent Pune to Bangalore taxi service. Affordable pricing, clean cab, and very professional travel experience.",
      rating: 5
    }
  ];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bangalore Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-bangalore-cab.jpg",
  "description": "Book Pune to Bangalore Cab Service with Shivai Travels for safe, comfortable, and affordable intercity travel. We offer one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for long-distance highway journeys, business trips, and family travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-bangalore-cab-service"
  }
};


  return (
    <div>


<Helmet>
  <title>Pune to Bangalore Cab Service | Affordable Outstation Taxi | Shivai Travels</title>

  <meta
    name="description"
    content="Book Pune to Bangalore cab service with Shivai Travels for safe and comfortable intercity travel. Affordable one-way and round-trip taxi options with sedan, SUV, Innova, and luxury cabs available 24x7."
  />

  <meta
    name="keywords"
    content="pune to bangalore cab, pune to bangalore taxi, cab from pune to bangalore, taxi from pune to bangalore, pune to bangalore cab service, pune to bangalore taxi fare, pune to bangalore one way cab, pune to bangalore round trip taxi, pune to bangalore cab booking, cheap pune to bangalore cab, best pune to bangalore taxi, sedan pune to bangalore cab, suv pune to bangalore taxi, innova pune to bangalore cab, outstation cab pune to bangalore"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/105.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobanglorecab;